import { ToastContainer as ReactToastifyContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const ToastContainer = () => <ReactToastifyContainer />;

export default ToastContainer;
